import { InputAdornment, Box, IconButton } from "@mui/material";
import { EyeOff, Eye, Close, CheckCircle, AlertCircle } from "@opengov/react-capital-assets";
import React from "react";
function createTypedSxStyles(styles) {
  return styles;
}
const circularProgressSizeProps = {
  tiny: {
    size: 12,
    thickness: 7
  },
  extraXSmall: {
    size: 13,
    thickness: 7
  },
  extraSmall: {
    size: 16,
    thickness: 7
  },
  small: {
    size: 20,
    thickness: 7
  },
  medium: {
    size: 40,
    thickness: 5
  },
  large: {
    size: 100,
    thickness: 3
  }
};
function getTextFieldIconByStatus(status) {
  switch (status) {
    // These icons are plain SVG components (not MUI SvgIcon) with a fixed 16px size, so MUI icon props such as
    // htmlColor and fontSize have no effect. Box + sx applies the palette colour as a class, which follows dark mode.
    // All of them are decorative (the field's state and helper text carry the status; the IconButton's aria-label names
    // the action), so hide them from assistive tech the way MUI SvgIcon does by default.
    case "error":
      return /* @__PURE__ */ React.createElement(Box, { component: AlertCircle, sx: { color: "error.main" }, "aria-hidden": "true", focusable: "false" });
    case "success":
      return /* @__PURE__ */ React.createElement(Box, { component: CheckCircle, sx: { color: "success.main" }, "aria-hidden": "true", focusable: "false" });
    case "clear":
      return /* @__PURE__ */ React.createElement(Close, { "aria-hidden": "true", focusable: "false" });
    case "visible":
      return /* @__PURE__ */ React.createElement(Eye, { "aria-hidden": "true", focusable: "false" });
    case "hidden":
      return /* @__PURE__ */ React.createElement(EyeOff, { "aria-hidden": "true", focusable: "false" });
    default:
      return null;
  }
}
const ADORNMENT_BUTTON_LABELS = {
  clear: "Clear",
  visible: "Show password",
  hidden: "Show password"
};
function getTextFieldEndAdornment(status, onClick, ariaLabel) {
  if (!status) return null;
  const icon = getTextFieldIconByStatus(status);
  const isPasswordToggle = status === "visible" || status === "hidden";
  const child = onClick && icon ? /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick,
      "aria-label": ariaLabel != null ? ariaLabel : ADORNMENT_BUTTON_LABELS[status],
      "aria-pressed": isPasswordToggle ? status === "visible" : void 0
    },
    icon
  ) : icon;
  return /* @__PURE__ */ React.createElement(InputAdornment, { position: "end" }, child);
}
const preventPasteNonNumericCharacters = (event) => {
  var _a;
  const pasteText = (_a = event.clipboardData) == null ? void 0 : _a.getData("text/plain");
  if (!pasteText) return;
  const formattedPasteText = pasteText.replace(/[^\d.-]/g, "");
  if (formattedPasteText === pasteText) return;
  event.preventDefault();
  const { target } = event;
  const { selectionStart = null, selectionEnd = null, value = "" } = target;
  if (selectionStart === null || selectionEnd === null) {
    target.value = formattedPasteText;
  } else {
    const textBefore = value.substring(0, selectionStart);
    const textAfter = value.substring(selectionEnd, value.length);
    target.value = `${textBefore}${formattedPasteText}${textAfter}`;
  }
};
const preventEnterNonNumericCharacters = (event) => {
  const { key } = event;
  if (event.getModifierState && (event.getModifierState("Meta") || event.getModifierState("Control") || event.getModifierState("Alt"))) {
    return;
  }
  if (key.length !== 1 || key === "\0") {
    return;
  }
  if ((key < "0" || key > "9") && key !== "." && key !== "-") {
    event.preventDefault();
  }
};
export {
  circularProgressSizeProps,
  createTypedSxStyles,
  getTextFieldEndAdornment,
  getTextFieldIconByStatus,
  preventEnterNonNumericCharacters,
  preventPasteNonNumericCharacters
};
//# sourceMappingURL=utils.js.map
